import type { FeatureCollection, Point, MultiPolygon } from 'geojson';

import { Sample } from './sampling';

// Type aliases for GeoJSON with custom properties
export type MultiPolygonFeatureCollection = FeatureCollection<
  MultiPolygon,
  MultiPolygonProperties
>;

export type OrdersListResponse = {
  count: number;
  next: string | null;
  previous: string | null;
  results: Order[];
};

export type Order = {
  id: number;
  name: string;
  organization: {
    name: string;
  };
  analysis_commands: AnalysisCommand[];
};

export type AnalysisCommand = {
  id: number;
  analysis_type: OrderType;
  nbr_samples: number;
  nbr_points: number;
  sampler: Sampler;
  laboratory: Laboratory;
  status: string;
  timelines: Timeline[];
  created_at: string;
  updated_at: string;
};

export type Sampler = {
  id: number;
  first_name: string;
  last_name: string;
};

export type Laboratory = {
  id: number;
  name: string;
};

export type Timeline = {
  id: number;
  name: string;
  start_date: string;
  end_date: string;
  color: string;
};

export type OrderDetailsResponse = {
  id: number;
  name: string;
  account: {
    id: number;
    first_name: string;
    last_name: string;
  };
  analysis_type: string;
  nbr_samples: number;
  nbr_points: number;
  sampler: Sampler;
  laboratory: Laboratory;
  nbr_fields: number;
  geosector: {
    id: number;
    name: string;
  };
  sampling_period: {
    id: number;
    name: string;
  };
  samples: Sample[];
  map: MultiPolygonFeatureCollection;
  created_at: string;
  updated_at: string;
  logs: {
    id: number;
    date: string;
    message: string;
  }[];
  plan_created: boolean;
  plan_created_at: string | null;
  sampler_found: boolean;
  sampler_found_at: string | null;
  sampled: boolean;
  sampled_at: string | null;
  received_laboratory: boolean;
  received_laboratory_at: string | null;
  received_results: boolean;
  received_results_at: string | null;
};

export type MultiPolygonProperties = {
  name: string;
  color: string;
};

export enum OrderType {
  Carbon = 'carbon',
  Density = 'density',
  Combo = 'combo',
}

export enum OrderStatus {
  Created = 'created',
  Received = 'received',
  InProgress = 'in_progress',
  PartiallyCompleted = 'partially_completed',
  Completed = 'completed',
  Canceled = 'canceled',
}

export type OrdersValuesFilters = {
  farm?: string;
  analysis_type?: string;
  sampler?: string;
  laboratory?: string;
};

export interface CreateOrderDto {
  farm: string;
  analysis_type: string;
  sampler: string;
  laboratory: string;
  points: string[];
}

export interface OrdersValuesResponse {
  farm: { id: number; name: string }[];
  analysis_type: { value: string; label: string }[];
  sampler: {
    id: number;
    last_name: string;
    first_name: string;
    role: { id: number; name: string } | null;
    organization: {
      id: number;
      name: string;
      parent: { id: number; name: string } | null;
      role: { id: number; name: string };
      country: string;
      created_at: string;
      updated_at: string;
    };
    last_login: string | null;
  }[];
  laboratory: { id: number; name: string }[];
  points: { id: number; code: string }[];
}
